module.exports = __webpack_public_path__ + "static/media/jslogo.50a67f1c.png";